/**
 * Contact form (inc/contact.php).
 *
 * Builds the form inside .contact-form: name, phone, message, a hidden honeypot, the consent note and
 * the button, in the volunteer form's look (vol-f, vol-field). It posts to the REST endpoint and swaps
 * in a thank-you message. Nothing runs without .contact-form.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var cfg = window.ssfContact || {};
	var t = window.ssfText || { f: String };

	function esc( s ) {
		var d = document.createElement( 'div' );
		d.textContent = s;
		return d.innerHTML;
	}

	// Wording kept in Elementor: paragraphs with the classes form-consent, form-button, form-note and
	// form-thanks inside the form box. Read once (the box is rebuilt after sending); the defaults in
	// window.ssfText stand in for any paragraph that was removed.
	function copyOf( holder, d ) {
		if ( ! holder.ssfCopy ) {
			var get = function ( cls, html ) {
				var el = holder.querySelector( '.' + cls );
				return el ? ( html ? el.innerHTML : el.textContent ).trim() : '';
			};
			holder.ssfCopy = {
				consent: get( 'form-consent', true ) || esc( d.consent ) + ' <a href="' + esc( t.privacy ) + '">' + esc( t.privacy_link ) + '</a>.',
				button: get( 'form-button' ) || d.button,
				note: get( 'form-note' ) || d.note,
				thanks: get( 'form-thanks' ) || d.thanks
			};
		}
		return holder.ssfCopy;
	}

	function setup( holder ) {
		var copy = copyOf( holder, { consent: t.msg_consent, button: t.msg_button, note: t.msg_note, thanks: t.f( t.msg_done, t.phone ) } );
		holder.innerHTML =
			'<form class="vol-f" novalidate>' +
			'<div class="vol-field"><label for="msg-name">' + esc( t.name_label ) + '</label><input id="msg-name" name="name" autocomplete="name" placeholder="' + esc( t.name_placeholder ) + '" maxlength="80"><p class="vol-err" id="msg-name-err"></p></div>' +
			'<div class="vol-field"><label for="msg-phone">' + esc( t.phone_label ) + '</label><input id="msg-phone" name="phone" inputmode="numeric" autocomplete="tel" placeholder="' + esc( t.phone_placeholder ) + '" maxlength="16"><p class="vol-err" id="msg-phone-err"></p></div>' +
			'<div class="vol-field"><label for="msg-text">' + esc( t.msg_label ) + '</label><textarea id="msg-text" name="message" rows="4" maxlength="1000" placeholder="' + esc( t.msg_placeholder ) + '"></textarea><p class="vol-err" id="msg-text-err"></p></div>' +
			'<div class="vol-hp" aria-hidden="true"><label for="msg-website">Website</label><input id="msg-website" name="website" tabindex="-1" autocomplete="off"></div>' +
			'<p class="vol-consent">' + copy.consent + '</p>' +
			'<button class="vol-btn" type="submit">' + esc( copy.button ) + '</button>' +
			'<p class="vol-note"><i aria-hidden="true"></i>' + esc( copy.note ) + '</p>' +
			'<p class="vol-fail" role="alert"></p>' +
			'</form>';

		var form = holder.querySelector( 'form' );

		function fieldError( input, msg ) {
			var err = form.querySelector( '#' + input.id + '-err' );
			if ( msg ) {
				input.setAttribute( 'aria-invalid', 'true' );
				input.setAttribute( 'aria-describedby', err.id );
			} else {
				input.removeAttribute( 'aria-invalid' );
			}
			err.textContent = msg || '';
		}

		form.addEventListener( 'submit', function ( e ) {
			e.preventDefault();
			var name = form.elements.name;
			var phone = form.elements.phone;
			var text = form.elements.message;
			var digits = phone.value.replace( /\D/g, '' ).replace( /^91(?=\d{10}$)/, '' );
			var checks = [
				[ name, name.value.trim() ? '' : t.err_name ],
				[ phone, /^[6-9]\d{9}$/.test( digits ) ? '' : t.err_phone ],
				[ text, text.value.trim().length >= 2 ? '' : t.err_msg ]
			];
			var bad = null;
			checks.forEach( function ( c ) {
				fieldError( c[ 0 ], c[ 1 ] );
				if ( c[ 1 ] && ! bad ) {
					bad = c[ 0 ];
				}
			} );
			if ( bad ) {
				bad.focus();
				return;
			}
			var btn = form.querySelector( '.vol-btn' );
			var fail = form.querySelector( '.vol-fail' );
			btn.disabled = true;
			btn.textContent = t.sending;
			fail.textContent = '';
			fetch( cfg.url, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': cfg.nonce || '' },
				body: JSON.stringify( { name: name.value.trim(), phone: digits, message: text.value.trim(), website: form.elements.website.value } )
			} ).then( function ( r ) {
				return r.json().then( function ( data ) {
					return { ok: r.ok, data: data };
				} );
			} ).then( function ( res ) {
				if ( ! res.ok ) {
					throw new Error( ( res.data && res.data.message ) || t.err_send );
				}
				holder.innerHTML = '<div class="vol-done" role="status" tabindex="-1"><span class="vol-tick" aria-hidden="true"></span>' +
					'<p class="vol-done-h">' + esc( t.f( t.thanks, name.value.trim() ) ) + '</p>' +
					'<p class="vol-done-p">' + esc( copy.thanks ) + '</p>' +
					'<button type="button" class="vol-again">' + esc( t.msg_again ) + '</button></div>';
				holder.querySelector( '.vol-again' ).addEventListener( 'click', function () {
					setup( holder );
					holder.querySelector( '#msg-name' ).focus();
				} );
				holder.querySelector( '.vol-done' ).focus();
			} ).catch( function ( err ) {
				btn.disabled = false;
				btn.textContent = copy.button;
				fail.textContent = err.message + ' ' + t.f( t.call_too, t.phone );
			} );
		} );
	}

	function init() {
		if ( document.body.classList.contains( 'elementor-editor-active' ) ) {
			return;
		}
		Array.prototype.forEach.call( document.querySelectorAll( '.contact-form' ), setup );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
